import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
import { graphql, Link } from 'gatsby';
import { ComponentHeader } from 'components/thumbprint-components';
export const pageQuery = graphql`
    {
        # Get links to by path to display in the navbar.
        platformNav: allSitePage(filter: { path: { glob: "/components/dropdown/*/" } }) {
            edges {
                node {
                    ...PlatformNavFragment
                }
            }
        }
    }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ComponentHeader data={props.data} mdxType="ComponentHeader" />
    <p>{`Dropdowns allow a user to make a selection from a predefined set of options. When presented on the screen, only the selected option (or a placeholder) is visible. When the dropbox is tapped, a UIPickerView is presented from the bottom of the user’s screen, allowing them to scroll through all of the available options.`}</p>
    <h2>{`Options`}</h2>
    <p>{`Any text can be set as a dropbox option, though long strings will truncate to fit a single line in the pickerView. Therefore, option titles should be as brief as is practicable.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/dropdown_options.png",
        "alt": "Dropdown options",
        "title": "Dropdown options"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let dropbox = Dropbox(optionTitles: ["Thing 1", "Thing 2"])

`}</code></pre>
    <h2>{`Placeholders`}</h2>
    <p>{`Dropdowns can be initialized with a placeholder string. The placeholder text is visible before the user has made any selection, but is not a selectable option in the pickerview, and thus can never be reselected by the user. The default placeholder text is “Choose one…”, but it can be set to a more descriptive value.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/dropdown_placeholder.png",
        "alt": "Dropdown placeholder",
        "title": "Dropdown placeholder"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`dropbox.placeholder = "Pick a thing"
`}</code></pre>
    <h2>{`States`}</h2>
    <p>{`Dropdowns support the following four states: default, highlighted, error, disabled.`}</p>
    <h4>{`Default`}</h4>
    <p>{`A dropbox in it’s normal state.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/dropdown.png",
        "alt": "Default dropdown",
        "title": "Default dropdown"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`dropbox.isEnabled = true
dropbox.hasError = false
dropbox.isHighlighted = false
`}</code></pre>
    <h4>{`Highlighted`}</h4>
    <p>{`The active dropbox with which the user is interacting. A dropbox will enter this state when tapped.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/dropdown_highlighed.png",
        "alt": "Highlighted dropdown",
        "title": "Highlighted dropdown"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`dropbox.isEnabled = true
dropbox.hasError = false
dropbox.isHighlighted = true
`}</code></pre>
    <h4>{`Error`}</h4>
    <p>{`A dropbox that is failing some validation and needs a users attention.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/dropdown_error.png",
        "alt": "Error dropdown",
        "title": "Error dropdown"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`dropbox.isEnabled = true
dropbox.hasError = true
`}</code></pre>
    <h3>{`Disabled`}</h3>
    <p>{`A dropdown that cannot be selected by the user. This may be the case when the dropbox only applies to a path other than the one that the user has chosen.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/dropdown_disabled.png",
        "alt": "Disabled dropdown",
        "title": "Disabled Dropdown"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`dropbox.isEnabled = false
`}</code></pre>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      